<template  >
<v-layout column fill-height="">
    <not-toolbar-sub :not="not"></not-toolbar-sub>

    <!-- //access page -->
    <not-access-deny-page 
        v-if="!accessPage"
        :not="not"
        :notShow="true"/> 
    <!-- //page -->
    <div v-else>
        <br> 
        <v-layout column fill-height align-center="" justify-center=""> 
            <v-col xm="10" sm="8" md="6"> 
                <v-card to="/settings/myprofile" color="primary" dark class="pa-2 mb-2" width="100%">
                    <v-layout>
                        <v-icon dark class="pr-2" >mdi-account</v-icon>
                        <div class="text-center not-fill-w ">My Profile</div>
                    </v-layout>
                </v-card> 

                <v-card to="/settings/permissions" color="primary" dark class="pa-2 mb-2" width="100%">
                    <v-layout>
                        <v-icon dark class="pr-2" >mdi-account-multiple</v-icon>
                        <div class="text-center not-fill-w ">User Groups / Permissions</div>
                    </v-layout>
                </v-card> 

                <v-card to="/settings/users" color="primary" dark class="pa-2 mb-2" width="100%">
                    <v-layout>
                        <v-icon dark class="pr-2" >mdi-account-multiple</v-icon>
                        <div class="text-center not-fill-w ">Users</div>
                    </v-layout>
                </v-card> 
                
                <v-card to="/settings/candidates" color="primary" dark class="pa-2 mb-2" width="100%">
                    <v-layout>
                        <v-icon dark class="pr-2" >mdi-account-tie</v-icon>
                        <div class="text-center not-fill-w ">Candidates</div>
                    </v-layout>
                </v-card> 

                <v-card to="/settings/parties" color="primary" dark class="pa-2 mb-2" width="100%">
                    <v-layout>
                        <v-icon dark class="pr-2" >mdi-account-group</v-icon>
                        <div class="text-center not-fill-w ">Parties</div>
                    </v-layout>
                </v-card> 

                <v-card to="/settings/reporters" color="primary" dark class="pa-2 mb-2" width="100%">
                    <v-layout>
                        <v-icon dark class="pr-2" >mdi-account-supervisor</v-icon>
                        <div class="text-center not-fill-w ">Reporters</div>
                    </v-layout>
                </v-card>  
                <v-card to="/settings/occurrences" color="primary" dark class="pa-2 mb-2" width="100%">
                    <v-layout>
                        <v-icon dark class="pr-2" >mdi-square-edit-outline</v-icon>
                        <div class="text-center not-fill-w ">Occurrences</div>
                    </v-layout>
                </v-card> 
                <v-card to="/settings/countries" color="primary" dark class="pa-2 mb-2" width="100%">
                    <v-layout>
                        <v-icon dark class="pr-2" >mdi-square-edit-outline</v-icon>
                        <div class="text-center not-fill-w ">Countries</div>
                    </v-layout>
                </v-card> 
                <v-card to="/settings/regions" color="primary" dark class="pa-2 mb-2" width="100%">
                    <v-layout>
                        <v-icon dark class="pr-2" >mdi-square-edit-outline</v-icon>
                        <div class="text-center not-fill-w ">Regions</div>
                    </v-layout>
                </v-card> 
                <v-card to="/settings/districts" color="primary" dark class="pa-2 mb-2" width="100%">
                    <v-layout>
                        <v-icon dark class="pr-2" >mdi-square-edit-outline</v-icon>
                        <div class="text-center not-fill-w ">Districts</div>
                    </v-layout>
                </v-card> 
                <v-card to="/settings/constituencies" color="primary" dark class="pa-2 mb-2" width="100%">
                    <v-layout>
                        <v-icon dark class="pr-2" >mdi-square-edit-outline</v-icon>
                        <div class="text-center not-fill-w ">Constituencies</div>
                    </v-layout>
                </v-card> 
                <v-card to="/settings/wards" color="primary" dark class="pa-2 mb-2" width="100%">
                    <v-layout>
                        <v-icon dark class="pr-2" >mdi-square-edit-outline</v-icon>
                        <div class="text-center not-fill-w ">Wards</div>
                    </v-layout>
                </v-card> 
                <v-card to="/settings/centres" color="primary" dark class="pa-2 mb-2" width="100%">
                    <v-layout>
                        <v-icon dark class="pr-2" >mdi-square-edit-outline</v-icon>
                        <div class="text-center not-fill-w ">Centres</div>
                    </v-layout>
                </v-card>   
            </v-col> 
        </v-layout>
        <br><br> 
    </div>
</v-layout>
</template>

<script> 
    
   let pageName = 'Settings'
    export default{
        name: pageName,
        props:['not'],  
        data: () => ({ 
            page_show: false
        }), 
        beforeCreate(){
             
        },
        created(){
             
        },
        mounted() {    
            this.pageLoad()
        },
        computed:{ 
            accessPage(){
                return this.not.ACCESS_PAGE(this.$route.name)
            },
            us(){
                return this.not.us
            },
            loading(){  
                return this.not.loading
            },
            processes(){  
                return this.not.processes
            }, 
            responses(){  
                return this.not.responses
            },
            
        },
        //------------methods---------------
        methods: { 
            clicked(){
                console.log("hhhhhhhhhhhh"); 
            },
            pageLoad(t){
                if (!t) {
                    t=400
                }
                setTimeout(()=>{
                    let us = this.loggedUser 
                    let ps = this.processes
                    let ld = this.loading
                    let res = this.responses
                    //this.page_show = false 

                    //CHECK USER STATE
                    if (ps.indexOf('logging')!==-1) { 
                        this.page_show = false
                    } else {    
                        this.page_show = this.not.ACCESS_PAGE(this.$route.name)
                    }  
                },t)
            }
        }, 
        watch: {
            us(v){
                
            },
            loading(value){
                this.pageLoad(1)
            },
            processes(value){
                this.pageLoad(1)
            },
            responses(value){
                this.pageLoad(1) 
            } 
        },
    } 
    
</script>
 
